import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57325be3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57325be3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57325be3')) {
      api.createRecord('57325be3', component.options)
    } else {
      api.reload('57325be3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57325be3&scoped=true&", function () {
      api.rerender('57325be3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/manageTaxConfig/index.vue"
export default component.exports